import "./report.css";
import cliente from "../../icons/cliente.svg";
import valor_medio from "../../icons/valor_medio.svg";
import {
  DataGridPremium,
  GridToolbarContainer,
  GridToolbarExportContainer,
  GridCsvExportMenuItem,
  GridExcelExportMenuItem,
} from "@mui/x-data-grid-premium";
import FormControl from "@mui/material/FormControl";
import { MultiSelect } from "react-multi-select-component";
import { ptBR } from "@mui/x-data-grid/locales";
import { ptBR as ptBRCore } from "@mui/x-data-grid/locales";
import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useCompany } from "../../components/context/CompanyContext";

import { userRequest } from "../../requestMethods";
import { effectiveStories } from "../../util/storeScope";
import { formatPricing } from "../../util/helper";

import Loading from "../../components/loading/loading";
import CustomGrid from "../../components/grid/CustomGrid";
export default function OrderSalesReport() {
  const currentUser = useSelector((state) => state.user.currentUser);
  const { companyId } = useCompany();
  const [storeIds, setStoreIds] = useState([]);
  const [selected, setSelected] = useState([]);
  const [salesGroup, setSalesGroup] = useState();
  const [gridRows, setGridRows] = useState([]);
  const [stories, setStories] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const nav = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    // if (selected.length === stories.length) {
    //   return setStoreIds([]);
    // }
    setStoreIds(selected.map((item) => item.value));
  }, [selected]);
  useEffect(() => {
    if (!currentUser) {
      nav(`../login`);
    }

    if (companyId > 0) {
      getStories(); // Carrega lojas apenas uma vez
    }
  }, [companyId]);
  useEffect(() => {
    if (companyId > 0) {
      carregarTudo();
    }
  }, [storeIds]);
  async function carregarTudo() {
    try {
      getAllOrdersSales();
      //agrupador();
    } catch (erro) {
      console.error("Erro ao carregar dados:", erro);
    } finally {
      setIsLoading(false);
    }
  }
  const getStories = async () => {
    const res = await userRequest.get(`${companyId}/store/stories`);
    const storeList = res.data.map((item) => ({
      label: item.store,
      value: item.storeId,
    }));
    setStories(storeList);

    // Se for Gerente e Admin, pré-seleciona a loja do usuário
    if (currentUser.position === "Gerente") {
      const userStore = storeList.find(
        (store) => store.value === currentUser.storeId,
      );
      if (userStore) {
        setSelected([userStore]);
      }
    }
  };
  const getAllOrdersSales = async () => {
    try {
      let url = "";
      setIsLoading(true);
      if (currentUser.isAdmin) {
        url = `${companyId}/reportOrderSales`;

        // Adiciona storeIds como query params (Gerente sempre restrito à própria loja)
        const eff = effectiveStories(currentUser, storeIds);
        if (eff.length > 0) {
          url += `?storeIds=${eff.join(",")}`;
        }
      }

      const res = await userRequest.get(url);
      if (res.data) {
        setSalesGroup(res.data);
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
    }
  };

  const _voltarTopo = () => {
    window.scrollTo(0, 0);
  };

  function CustomToolbar() {
    return (
      <GridToolbarContainer>
        <GridToolbarExport />
      </GridToolbarContainer>
    );
  }
  const GridToolbarExport = ({
    csvOptions,
    printOptions,
    excelOptions,
    ...other
  }) => (
    <GridToolbarExportContainer {...other}>
      <GridCsvExportMenuItem options={csvOptions} />
      <GridExcelExportMenuItem options={excelOptions} />
    </GridToolbarExportContainer>
  );

  const columns = [
    {
      field: "nome_cliente",
      type: "text",
      headerName: "Cliente",
      flex: 1.5,
      minWidth: 200,
      align: "center",
      headerAlign: "center",

    },
    {
      field: "contact_cliente",
      type: "text",
      headerName: "Tel",
      flex: 1.5,
      minWidth: 200,
      align: "center",
      headerAlign: "center",

    },
    {
      field: "grupo_compra",
      type: "text",
      headerName: "Grupo de Compra",
      width: 150,
      align: "center",
      headerAlign: "center",

    },
    {
      field: "categoria",
      type: "text",
      headerName: "Categoria",
      width: 180,
      align: "center",
      headerAlign: "center",

    },
    {
      field: "total_compras",
      type: "number",
      headerName: "Nº Compras",
      width: 120,
      align: "center",
      headerAlign: "center",

    },
    {
      field: "valor_ultima_compra",
      type: "number",
      headerName: "Valor Última Compra",
      width: 200,
      headerAlign: "center",
      align: "right",
      format: "BRL",
    },
    {
      field: "ultima_compra",
      type: "date",
      headerName: "Data Última Compra",
      width: 180,
      format: "dd/MM/yyyy",
      align: "center",
      headerAlign: "center",

    },
    {
      field: "dias_desde_ultima_compra",
      type: "number",
      headerName: "Dias desde Última",
      width: 160,
      align: "center",
      headerAlign: "center",

    },
    {
      field: "vendedor",
      type: "text",
      headerName: "Vendedor",
      width: 180,
      align: "center",
      headerAlign: "center",

    },
  ];

  const grupo0 = salesGroup
    ? salesGroup.filter((r) => r.total_compras === 0)
    : [];
  const grupo1 = salesGroup
    ? salesGroup.filter((r) => r.total_compras === 1)
    : [];
  const grupo2 = salesGroup
    ? salesGroup.filter((r) => r.total_compras >= 2)
    : [];

  const somaValor = (lista) =>
    lista.reduce((acc, r) => acc + (Number(r.valor_ultima_compra) || 0), 0);

  const porDias = (lista) => ({
    ativo: lista.filter((r) => r.dias_desde_ultima_compra <= 120),
    preInativo: lista.filter(
      (r) =>
        r.dias_desde_ultima_compra > 120 && r.dias_desde_ultima_compra <= 180,
    ),
    inativo: lista.filter(
      (r) =>
        r.dias_desde_ultima_compra > 180 && r.dias_desde_ultima_compra <= 365,
    ),
    critico: lista.filter((r) => r.dias_desde_ultima_compra > 365),
  });

  const g1d = porDias(grupo1);
  const g2d = porDias(grupo2);

  return (
    <div className="div_home_Container">
      {isLoading ? (
        <Loading />
      ) : (
        <>
          <table width="100%" className="tableSpaceTab">
            <tbody>
              <tr align="right">
                <FormControl sx={{ minWidth: 300 }} size="small">
                  <MultiSelect
                    overrideStrings={{
                      selectAll: "Todos",
                      search: "Buscar",
                      selectSomeItems: "Lojas",
                      allItemsAreSelected: "Todas lojas selecionadas.",
                      noOptions: "Nehuma loja",
                    }}
                    options={stories}
                    value={selected}
                    onChange={setSelected}
                    labelledBy="Lojas"
                    disabled={
                      currentUser.position === "Gerente" &&
                      currentUser.isAdmin === true
                    }
                  />
                </FormControl>
              </tr>
              {/* Bloco 0 compras */}
              <tr>
                <div className="div_home_custom">
                  <table className="table">
                    <tbody>
                      <tr>
                        <td>
                          <tr>
                            <td>
                              <img src={valor_medio} alt="" />
                            </td>
                            <td>
                              <tr className="labelTitle">
                                0 Compras — Nunca comprou
                              </tr>
                            </td>
                          </tr>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table className="table_painel">
                    <tbody>
                      <tr>
                        <td width="100%" className="status_painel">
                          Não comprou ({grupo0.length})
                        </td>
                      </tr>
                      <tr>
                        <td
                          width="100%"
                          className="labelValue_painel_black_vlr"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setGridRows(grupo0);
                            window.scrollTo(0, document.body.scrollHeight);
                          }}
                        >
                          {formatPricing(somaValor(grupo0))}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </tr>

              {/* Bloco 1 compra */}
              <tr>
                <div className="div_home_custom">
                  <table className="table">
                    <tbody>
                      <tr>
                        <td>
                          <tr>
                            <td>
                              <img src={valor_medio} alt="" />
                            </td>
                            <td>
                              <tr className="labelTitle">1 Compra</tr>
                            </td>
                          </tr>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table className="table_painel">
                    <tbody>
                      <tr>
                        <td width="25%" className="status_painel">
                          Ativo ({g1d.ativo.length})<br />
                          <span style={{ fontSize: 11, fontWeight: 400 }}>
                            ≤ 120 dias
                          </span>
                        </td>
                        <td width="25%" className="status_painel">
                          Pré-Inativo ({g1d.preInativo.length})<br />
                          <span style={{ fontSize: 11, fontWeight: 400 }}>
                            121 a 180 dias
                          </span>
                        </td>
                        <td width="25%" className="status_painel">
                          Inativo ({g1d.inativo.length})<br />
                          <span style={{ fontSize: 11, fontWeight: 400 }}>
                            &gt; 180 a 365 dias
                          </span>
                        </td>
                        <td width="25%" className="status_painel">
                          Inativo Crítico ({g1d.critico.length})<br />
                          <span style={{ fontSize: 11, fontWeight: 400 }}>
                            &gt; 365 dias
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td
                          width="25%"
                          className="labelValue_painel_black_vlr"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setGridRows(g1d.ativo);
                            window.scrollTo(0, document.body.scrollHeight);
                          }}
                        >
                          {formatPricing(somaValor(g1d.ativo))}
                        </td>
                        <td
                          width="25%"
                          className="labelValue_painel_black_vlr"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setGridRows(g1d.preInativo);
                            window.scrollTo(0, document.body.scrollHeight);
                          }}
                        >
                          {formatPricing(somaValor(g1d.preInativo))}
                        </td>
                        <td
                          width="25%"
                          className="labelValue_painel_black_vlr"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setGridRows(g1d.inativo);
                            window.scrollTo(0, document.body.scrollHeight);
                          }}
                        >
                          {formatPricing(somaValor(g1d.inativo))}
                        </td>
                        <td
                          width="25%"
                          className="labelValue_painel_black_vlr"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setGridRows(g1d.critico);
                            window.scrollTo(0, document.body.scrollHeight);
                          }}
                        >
                          {formatPricing(somaValor(g1d.critico))}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </tr>

              {/* Bloco 2+ compras */}
              <tr>
                <div className="div_home_custom">
                  <table className="table">
                    <tbody>
                      <tr>
                        <td>
                          <tr>
                            <td>
                              <img src={valor_medio} alt="" />
                            </td>
                            <td>
                              <tr className="labelTitle">2+ Compras</tr>
                            </td>
                          </tr>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <table className="table_painel">
                    <tbody>
                      <tr>
                        <td width="25%" className="status_painel">
                          Ativo ({g2d.ativo.length})<br />
                          <span style={{ fontSize: 11, fontWeight: 400 }}>
                            ≤ 120 dias
                          </span>
                        </td>
                        <td width="25%" className="status_painel">
                          Pré-Inativo ({g2d.preInativo.length})<br />
                          <span style={{ fontSize: 11, fontWeight: 400 }}>
                            121 a 180 dias
                          </span>
                        </td>
                        <td width="25%" className="status_painel">
                          Inativo ({g2d.inativo.length})<br />
                          <span style={{ fontSize: 11, fontWeight: 400 }}>
                            &gt; 180 a 365 dias
                          </span>
                        </td>
                        <td width="25%" className="status_painel">
                          Inativo Crítico ({g2d.critico.length})<br />
                          <span style={{ fontSize: 11, fontWeight: 400 }}>
                            &gt; 365 dias
                          </span>
                        </td>
                      </tr>
                      <tr>
                        <td
                          width="25%"
                          className="labelValue_painel_black_vlr"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setGridRows(g2d.ativo);
                            window.scrollTo(0, document.body.scrollHeight);
                          }}
                        >
                          {formatPricing(somaValor(g2d.ativo))}
                        </td>
                        <td
                          width="25%"
                          className="labelValue_painel_black_vlr"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setGridRows(g2d.preInativo);
                            window.scrollTo(0, document.body.scrollHeight);
                          }}
                        >
                          {formatPricing(somaValor(g2d.preInativo))}
                        </td>
                        <td
                          width="25%"
                          className="labelValue_painel_black_vlr"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setGridRows(g2d.inativo);
                            window.scrollTo(0, document.body.scrollHeight);
                          }}
                        >
                          {formatPricing(somaValor(g2d.inativo))}
                        </td>
                        <td
                          width="25%"
                          className="labelValue_painel_black_vlr"
                          style={{ cursor: "pointer" }}
                          onClick={() => {
                            setGridRows(g2d.critico);
                            window.scrollTo(0, document.body.scrollHeight);
                          }}
                        >
                          {formatPricing(somaValor(g2d.critico))}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </tr>
              <tr>
                <div className="div_home_custom">
                  <table className="table">
                    <tbody>
                      <tr>
                        <td align="left" width="100%">
                          <tr>
                            <td>
                              <img src={cliente} alt="" />
                            </td>
                            <td>
                              <tr className="labelTitle">Vendas Estratégica</tr>
                              <tr className="labelMsgData">
                                Exibindo todos os dados
                              </tr>
                            </td>
                          </tr>
                        </td>
                        <td align="left" width="0%">
                          {" "}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  {gridRows.length > 0 && (
                    <div
                      className="div_custom_UpdateItem full-width"
                      style={{ height: 700, width: "100%" }}
                    >
                      <CustomGrid
                        gridId="salesReportGrid"
                        rows={gridRows}
                        columns={[
                          {
                            field: "nome_cliente",
                            type: "text",
                            headerName: "Cliente",
                            width: 200,
                          },
                          {
                            field: "cnpj_cpf",
                            type: "text",
                            headerName: "CNPJ/CPF",
                            width: 160,
                            align: "center",
                            headerAlign: "center",
                          },
                          {
                            field: "contact_cliente",
                            type: "text",
                            headerName: "Tel",
                            width: 150,
                            align: "center",
                            headerAlign: "center",
                          },
                          {
                            field: "grupo_compra",
                            type: "text",
                            headerName: "Grupo de Compra",
                            width: 150,
                            align: "center",
                            headerAlign: "center",
                          },
                          {
                            field: "categoria",
                            type: "text",
                            headerName: "Categoria",
                            width: 180,
                            align: "center",
                            headerAlign: "center",
                          },
                          {
                            field: "total_compras",
                            type: "number",
                            headerName: "Nº Compras",
                            width: 120,
                            align: "center",
                            headerAlign: "center",
                          },
                          {
                            field: "valor_ultima_compra",
                            type: "number",
                            headerName: "Valor Última Compra",
                            width: 200,
                            align: "right",
                            headerAlign: "center",
                            format: "BRL",
                          },
                          {
                            field: "ultima_compra",
                            type: "date",
                            headerName: "Data Última Compra",
                            width: 180,
                            align: "center",
                            headerAlign: "center",
                            format: "dd/MM/yyyy",
                          },
                          {
                            field: "dias_desde_ultima_compra",
                            type: "number",
                            headerName: "Dias desde Última",
                            width: 160,
                            align: "center",
                            headerAlign: "center",
                          },
                          {
                            field: "vendedor",
                            type: "text",
                            headerName: "Vendedor",
                            width: 180,
                            align: "center",
                            headerAlign: "center",
                          },
                        ]}
                        pageSize={25}
                        checkboxSelection={false}
                      />
                    </div>
                  )}
                </div>
              </tr>
            </tbody>
          </table>
        </>
      )}
      <div className="divRodape" onClick={_voltarTopo}>
        voltar ao topo
      </div>
    </div>
  );
}
